export var AlchemySignerStatus;
(function (AlchemySignerStatus) {
    AlchemySignerStatus["INITIALIZING"] = "INITIALIZING";
    AlchemySignerStatus["CONNECTED"] = "CONNECTED";
    AlchemySignerStatus["DISCONNECTED"] = "DISCONNECTED";
    AlchemySignerStatus["AUTHENTICATING_PASSKEY"] = "AUTHENTICATING_PASSKEY";
    AlchemySignerStatus["AUTHENTICATING_EMAIL"] = "AUTHENTICATING_EMAIL";
    AlchemySignerStatus["AUTHENTICATING_OAUTH"] = "AUTHENTICATING_OAUTH";
    AlchemySignerStatus["AWAITING_EMAIL_AUTH"] = "AWAITING_EMAIL_AUTH";
    AlchemySignerStatus["AWAITING_OTP_AUTH"] = "AWAITING_OTP_AUTH";
})(AlchemySignerStatus || (AlchemySignerStatus = {}));
//# sourceMappingURL=types.js.map